var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88867 18.2695C12.0104 18.2695 14.0452 17.4267 15.5455 15.9264C17.0458 14.4261 17.8887 12.3913 17.8887 10.2695C17.8887 8.1478 17.0458 6.11297 15.5455 4.61268C14.0452 3.11239 12.0104 2.26953 9.88867 2.26953",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88867 10.2695H11.8887M11.8887 10.2695L8.88867 7.26953M11.8887 10.2695L8.88867 13.2695",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconLogin);
export default __webpack_public_path__ + "static/media/buttonIconLogin.dd20a2ef56454d02bc7202737b1fd059.svg";
export { ForwardRef as ReactComponent };